import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;

  div {
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #C8C8C8;
  }

  div.selected {
    color: #3D6666;
  }

  div.available {
    color: #3D6666;
  }

  div:first-of-type {
    margin-right: 6px;
  }

  div:last-of-type {
    margin-left: 6px;
  }
`